<mat-icon *ngIf="success" class="success-worklist-icon worklist-success-failure-icon-font"
          matTooltipShowDelay="500"
          [matTooltip]="tooltipSuccess">check_circle</mat-icon>

<mat-icon *ngIf="failure" class="failure-worklist-icon worklist-success-failure-icon-font"
          matTooltipShowDelay="500"
          [matTooltip]="tooltipFailure">error</mat-icon>

<mat-icon *ngIf="cancelled" class="cancelled-worklist-icon worklist-success-failure-icon-font"
          matTooltipShowDelay="500"
          [matTooltip]="tooltipCancelled">error</mat-icon>
